import { render, staticRenderFns } from "./MsTooltip.vue?vue&type=template&id=8fec0e18"
import script from "./MsTooltip.vue?vue&type=script&lang=js"
export * from "./MsTooltip.vue?vue&type=script&lang=js"
import style0 from "./MsTooltip.vue?vue&type=style&index=0&id=8fec0e18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports